// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-7c13f232] .pubaudio-search-wrapper {
  display: flex;
  flex-wrap: wrap;
}
[data-v-7c13f232] .publication-audio-message {
  display: flex;
}
[data-v-7c13f232] .publication-audio-message .bottom-audio-section {
  display: flex;
  justify-content: space-between;
}
[data-v-7c13f232] .publication-audio-message .name-text {
  max-width: 282px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 16px;
}
[data-v-7c13f232] .publication-audio-message .audio-progress .slider {
  width: 190px;
  margin-right: 12px;
}
[data-v-7c13f232] .publication-audio-message .audio-volume .slider {
  width: 80px;
}
[data-v-7c13f232] .publication-audio-message .audio-time {
  margin: auto;
  color: var(--message-grey-color);
  font-size: 1em;
  margin-left: -42px;
  margin-top: 18px;
}
[data-v-7c13f232] .publication-audio-message .slider {
  display: flex;
  margin-top: -34px;
}
[data-v-7c13f232] .publication-audio-message .message-btn {
  margin-right: 4px;
  margin-left: 4px;
  margin-bottom: 19px;
}
[data-v-7c13f232] .publication-audio-message .aux-download-btn {
  position: relative;
  width: 20px;
  height: 20px;
  display: inline-flex;
  background-color: #76a7f3;
  border-radius: 50%;
  border: 1px var(--shifted-circle-border-color) solid;
  margin-top: -37px;
  margin-left: 28px;
  z-index: 100;
}
[data-v-7c13f232] .publication-audio-message .aux-download-btn i {
  position: relative;
  font-size: small;
  top: 3px;
  left: 3px;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/PublicationAudioItemSearch.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,oDAAoD;EACpD,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,YAAY;AACd","sourcesContent":["[data-v-7c13f232] .pubaudio-search-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n}\n[data-v-7c13f232] .publication-audio-message {\n  display: flex;\n}\n[data-v-7c13f232] .publication-audio-message .bottom-audio-section {\n  display: flex;\n  justify-content: space-between;\n}\n[data-v-7c13f232] .publication-audio-message .name-text {\n  max-width: 282px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-top: 16px;\n}\n[data-v-7c13f232] .publication-audio-message .audio-progress .slider {\n  width: 190px;\n  margin-right: 12px;\n}\n[data-v-7c13f232] .publication-audio-message .audio-volume .slider {\n  width: 80px;\n}\n[data-v-7c13f232] .publication-audio-message .audio-time {\n  margin: auto;\n  color: var(--message-grey-color);\n  font-size: 1em;\n  margin-left: -42px;\n  margin-top: 18px;\n}\n[data-v-7c13f232] .publication-audio-message .slider {\n  display: flex;\n  margin-top: -34px;\n}\n[data-v-7c13f232] .publication-audio-message .message-btn {\n  margin-right: 4px;\n  margin-left: 4px;\n  margin-bottom: 19px;\n}\n[data-v-7c13f232] .publication-audio-message .aux-download-btn {\n  position: relative;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  border: 1px var(--shifted-circle-border-color) solid;\n  margin-top: -37px;\n  margin-left: 28px;\n  z-index: 100;\n}\n[data-v-7c13f232] .publication-audio-message .aux-download-btn i {\n  position: relative;\n  font-size: small;\n  top: 3px;\n  left: 3px;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
